import { TrelloStorage } from '@trello/storage';

import { SharedState } from './SharedState';

export class PersistentSharedState<
  Value extends string | number | object
> extends SharedState<Value> {
  #hasSyncLock: boolean = false;

  constructor(initialValue: Value, storageKey: string) {
    super(TrelloStorage.get(storageKey) ?? initialValue);

    this.subscribe((value) => {
      if (this.#hasSyncLock) {
        return;
      }

      TrelloStorage.set(storageKey, value);
    });

    TrelloStorage.listenSyncedAcrossBrowser(({ key, newValue }) => {
      if (key !== storageKey) {
        return;
      }

      const value =
        newValue !== null ? (JSON.parse(newValue) as Value) : initialValue;

      this.#hasSyncLock = true;
      this.setValue(value);
      this.#hasSyncLock = false;
    });
  }
}
